<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-lg">
      <!-- Brand Link -->
      <!-- <a class="navbar-brand" href="index.html">Sakha</a> -->
      <router-link :to="'/member/home'" class="navbar-brand">Sakha
                          </router-link>
      <div class="d-flex align-items-start">
        <!-- Navbar Toggle Button -->
        <button class="navbar-toggler collapsed" type="button" @click="toggleNav" aria-controls="mainNav"
          :aria-expanded="isMainNavOpen" aria-label="Toggle navigation">
          <i class="fa-icon fa-regular fa-bars"></i>
        </button>

        <!-- Main Navigation Links -->
        <div class="collapse navbar-collapse" :class="{ show: isMainNavOpen }" id="mainNav">
          <ul class="navbar-nav">
            <li class="nav-item">
              <a class="nav-link active" aria-current="page" @click="gotolink('/member/home')">
                หน้าแรก
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" aria-current="page" @click="gotolink('/article')">
                โปรโมชั่น
              </a>
            </li>
            <li class="nav-item">
              <a style="cursor: pointer;" class="nav-link"  @click="openLine()">ติดต่อเรา</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
// import CallCenterModal from '@/components/modals/CallCenterModal'
export default {
  data () {
    return {
      language: localStorage.getItem('locale') ?? 'th',
      AGENT_EXT_NAME: process.env.VUE_APP_EXT_NAME,
      isMainNavOpen: false,
      isUserNavOpen: false,
      isDropdownOpen: false,
      activePage: 'home'
    }
  },
  async mounted () {
    document.addEventListener('click', this.handleClickOutside)
    console.log(this.$route.meta.isNoRequestFooter)
    await this.reqConfig({
      id: process.env.VUE_APP_AG_ID,
      afKey: this.afKey,
      agKey: this.agKey
    })
    if (this.isMember) {
      console.log('this.hasBank')
      console.log(this.hasBank)
      if (this.hasBank === null) {
        this.getMyAccountBanks()
      }
    }
    // await this.reqConfig(process.env.VUE_APP_AG_ID)
  },
  beforeUnmount () {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    ...mapActions(['loginAction', 'requestUsername', 'setLoading', 'openErrorPopup', 'reqConfig']),
    toggleNav () {
      this.isMainNavOpen = !this.isMainNavOpen
    },
    toggleUserNav () {
      this.isUserNavOpen = !this.isUserNavOpen
    },
    toggleDropdown () {
      this.isDropdownOpen = !this.isDropdownOpen
    },
    setActivePage (page) {
      this.activePage = page
    },
    openLine () {
      window.open(this.getLine)
    },
    isPageActive (pageName) {
      return (this.$route.name === pageName)
    },
    isDisabled () {
      if (this.hasBank === null) {
        return 'disabled'
      }
      return ''
    },
    gotolink (link) {
      this.isDropdownOpen = false
      this.isMainNavOpen = false
      this.isUserNavOpen = false
      this.$router.replace(link)
    },
    handleClickOutside (event) {
      if (this.$refs.dropdownMenu && !this.$refs.dropdownMenu.contains(event.target)) {
        this.isDropdownOpen = false
      }
    }
  },
  computed: {
    ...mapState({
      hasBank: state => state.bankModule.hasBank,
      isMember: (state) => state.authModule.isMember,
      afKey: (state) => state.registerModule.afKey,
      agKey: (state) => state.registerModule.agKey
    }),
    ...mapGetters(['getBalance', 'getUsername', 'getLine', 'getLogo1', 'getLine']),
    iconsFlags () {
      return this.language === 'th' ? 'flag-icon flag-icon-th' : 'flag-icon flag-icon-gb'
    },
    settingBank () {
      return this.hasBank ? '/member/settings/bank' : '/member/settings/bank/add'
    },
    deposit () {
      return this.hasBank ? '/member/deposit' : '/member/settings/bank/add'
    }
  }
}
</script>

<style scoped>
/* Optional custom styling */
</style>
